import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const pageTemplateService = {
  getPagesForActivity: async (user, templateId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/page/activity/${templateId}`,
      getAxiosOptions(user)
    )
  },

  getDefaultPage: async (user, process_id) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/process-data/default-page-sequence/${process_id}`,
        getAxiosOptions(user)
      )
    ).data
  },

  updatePageSequences: async (user, data) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/page/update-sequence`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },

  addPageTemplate: async (user, activityTemplateId) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/page`,
        {
          activity_template_id: activityTemplateId,
          user_id: user.id,
        },
        getAxiosOptions(user)
      )
    ).data
  },
}
